"use client";
import React from "react";
import * as yup from "yup";
import { Modal, Divider, Segment, Icon, Grid, Loader } from "semantic-ui-react";
import { Title, Field, ButtonItem, InText, Segmant } from "../../components";
import { Button, Form, Input } from "formik-semantic-ui";
import { styles } from "./element";

const ForgotpasswordModal = ({
  open,
  submit,
  next,
  iconclick,
  s_firstname_err_status,
  s_firstname_err_msg,
  f_email_err_status,
  f_email_err_msg,
  s_lastname_err_status,
  s_lastname_err_msg,
  firstNameChage,
  f_email_success,
  f_email_success_msg,
  verificationdisplay,
  newpassword,
  f_veri_err_status,
  f_veri_err_msg,
  f_pass_txt,
  f_pass_err_status,
  f_pass_err_msg,
  changemsg,
  isSaving,
}) => {
  const validations = yup.object().shape({
    // first_name: yup.string().min(3, "Minimum 3 characters").max(15,"Maximum 15 characters").required("Name is required"),
    // last_name: yup.string().min(3, "Minimum 3 characters").max(15,"Maximum 15 characters"),
    email: yup.string().email("Invalid Email").required("Email is required"),
    verificationcode: yup.string().required("Verificationcode is required"),
    newpass: yup.string().required("Password is required"),
  });

  return (
    <Modal open={open} size="tiny" style={styles}>
      <Segment padded>
        <Grid>
          <Grid.Row>
            <Grid.Column width={14}>
              <Title floated="left" content="Forgot password" size="large" />
            </Grid.Column>
            <Grid.Column verticalAlign="middle" width={2}>
              <span onClick={iconclick}>
                <Icon link size="large" name="close" />
              </span>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider hidden />
        <Modal.Content>
          <Form
            initialValues={{
              email: "",
              verificationcode: "",
              newpass: "",
              id: "fmodal",
            }}
            onSubmit={(values) => submit(values)}
            ignoreLoading={true}
            // validationSchema={validations}
          >
            <Input
              name="email"
              inputProps={{
                placeholder: "Email",
              }}
            />
            {f_email_err_status ? (
              <span className="sui-error-message">{f_email_err_msg}</span>
            ) : null}
            {f_email_success ? (
              <span style={{ color: "green" }}>{f_email_success_msg}</span>
            ) : null}

            {verificationdisplay && (
              <Input
                name="verificationcode"
                inputProps={{
                  placeholder: "Enter varification code",
                }}
              />
            )}
            {f_veri_err_status ? (
              <span className="sui-error-message">{f_veri_err_msg}</span>
            ) : null}

            {newpassword && (
              <>
                <Input
                  name="newpass"
                  inputProps={{
                    placeholder: "Enter New Password",
                    type: "password",
                  }}
                />
                <br />
                <span>{f_pass_txt}</span>
              </>
            )}

            {f_pass_err_status ? (
              <span className="sui-error-message">{f_pass_err_msg}</span>
            ) : null}
            {changemsg ? (
              <span style={{ color: "green" }}>{changemsg}</span>
            ) : null}
            <Divider hidden />
            <Button.Submit fluid primary disabled={isSaving}>
              {isSaving && <Loader active inline size="tiny" />} Submit
            </Button.Submit>
          </Form>

          <Divider hidden />
          <Divider hidden />
          {/* <InText
						textAlign="center"
						content="By joining you agree to RYLY's Terms of Use and Privacy Policy"
					/> */}
        </Modal.Content>
      </Segment>
    </Modal>
  );
};

// SignupModal.propTypes = {
// 	title : PropTypes.string,
// };
export default ForgotpasswordModal;
